const initialState = {
  showMinimumModal: false,
  showNotSupportedModal: false,
  pendingBonus: null,
};

const bonusModalState = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  switch (action.type) {
    case 'BONUS_MODAL_SET_STATE':
      return {
        ...state.bonusModalState,
        ...action.payload,
      };
    case 'BONUS_MODAL_RESET':
      return initialState;
    default:
      return state.bonusModalState || initialState;
  }
};

export { bonusModalState };
